import { Injectable } from '@angular/core';
import { APIService } from '@shared/index';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private readonly apiService: APIService) { }


  addSurvey(surveyData: any) {
    return this.apiService.postWithAllResponse('ParkingLot/AddParkingLotSurvey', surveyData);
  }

  parkingLotsBookingDetailsByID(bookingId: string) {
    return this.apiService.postWithAllResponse('ParkingLot/GetParkingLotBookingDetailsById',bookingId);
  }
  getParkingLotSurveyDetailsByFilters(requestData: any) {
    return this.apiService.postWithAllResponse('ParkingLot/GetParkingLotSurveyDetailsByFilters', requestData);
  }
}
  